/*
*@Author: dcl
*@Description: 信息披露主页-河北
*@Date: 2023-03-14 15:08:12
*/
<template>
<div class="i-box">
    <div class="box-img">
        <!-- <div class="img-con">
            <el-image class="con-img" :src="info_1" fit="cover" />
        </div> -->
        <div class="con-txt">
            <div class="txt-zw">公开信息披露</div>
            <div class="txt-yw">INFO DISCLOSURE</div>
        </div>
    </div>
    <div class="box-content">
        <nav class="content-nav">
            <div class="nav-title">INFO DISCLOSURE</div>
            <div class="nav-list">
                <div :ref="'info'+index" class="list-info" v-for="(item, index) in infoList" :key="index + 'infoList'" @click="changeItem(item.name, item.nameE, index)">
                    <div class="info-txt">{{ item.name }}</div>
                </div>
            </div>
        </nav>
        <div class="content-con">
            <div class="con-title">
                <div class="title-txt">{{ currentName }}</div>
            </div>
            <div class="con-sec">
                <General v-if="current === 'general'" />
                <Base v-else-if="current === 'base'" />
                <!-- <Branch v-else-if="current === 'branch'" /> -->
                <Major v-else />
                <!-- <Complain v-else-if="current === 'complain'" />
                <Cooperation v-else-if="current === 'cooperation'" />
                <Relation v-else-if="current === 'relation'" />
                <Support v-else /> -->
            </div>
        </div>
    </div>
</div>
</template>

<script>
import General from "./general.vue";
import Base from "./base.vue";
import Branch from "./branch.vue";
import Major from "./major.vue";
// import Business from "./business.vue";
// import License from "./license.vue";
// import Complain from "./complain.vue";
// import Cooperation from "./cooperation.vue";
// import Relation from "./relation.vue";
// import Support from "./support.vue";
export default {
    components: {
        General,
        Base,
        Branch,
        Major
        // Business,
        // License,
        // Complain,
        // Cooperation,
        // Relation,
        // Support
    },
    data() {
        return {
            currentName: "机构概况",
            current: "general",
            info_1: require("../../assets/info_1.jpg"),
            infoList: [{
                    name: "机构概况",
                    nameE: "general"
                },
                {
                    name: "基本财务信息",
                    nameE: "base"
                },
                // {
                //     name: "合作保险机构信息披露",
                //     nameE: "branch"
                // },
                {
                    name: "重大事项信息",
                    nameE: "major"
                }
            ]
        };
    },
    created() {
        sessionStorage.setItem('hebei', true)
    },
    mounted() {
        this.$refs['info0'][0].style.backgroundColor = '#FF9600'
        this.$refs['info0'][0].style.color = '#FFFFFF'
        this.$refs['info0'][0].style.color = '#FFFFFF'
    },
    methods: {
        changeItem(name, v, i) {
            this.currentName = name
            this.current = v
            for (let j = 0; j < this.infoList.length; j++) {
                this.$refs['info' + j][0].style.backgroundColor = 'rgb(255, 255, 255)'
                this.$refs['info' + j][0].style.color = '#2c3e50'
            }
            this.$refs['info' + i][0].style.backgroundColor = '#FF9600'
            this.$refs['info' + i][0].style.color = '#FFFFFF'
        }
    }
};
</script>

<style lang="less" scoped>
.i-box {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: #fff;
    text-align: left;

    .box-img {
        display: flex;
        flex-direction: column;
        align-items: center;
        position: relative;
        width: 100%;
        color: #ffffff;
        background: url('../../assets/info_1.jpg') no-repeat center;
        background-size: cover;
        width: 100%;
        height: 12.47rem;
        max-width: 1920px;

        .con-txt {
            position: absolute;
            bottom: 2.37rem;
            left: 2.97rem;
            padding: 0rem 0.97rem 0.23rem;
            background: rgba(0, 0, 0, 0.25);

            .txt-zw {
                font-size: 1.7rem;
            }

            .txt-yw {
                font-size: 1rem;
            }
        }
    }

    .box-content {
        display: flex;
        flex-direction: column;
        width: 100%;

        .content-nav {
            display: flex;
            flex-direction: column;
            margin: .5rem 0px 0px 0rem;
            font-size: 0.53rem;

            .nav-title {
                margin: 0px 0px .4rem;
                font-size: 0.8rem;
                color: #EFF0F2;
                position: relative;
                top: 2rem;
            }

            .nav-title::before {
                content: '信息披露专栏';
                font-size: 1.13rem;
                color: #636363;
                position: absolute;
                top: -.97rem;
                left: 0;
            }

            .nav-list {
                display: flex;
                flex-direction: row;
                border-bottom: 1px solid #ccc;
                font-size: .53rem;
                margin-top: 2rem;

                .list-info {
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                    justify-content: center;
                    padding: .57rem .5rem;
                    // width: calc(100% / 6);
                }
            }
        }

        .content-con {
            display: flex;
            flex-direction: column;
            margin: 0.7rem 0rem 0 0rem;
            width: 100%;

            .con-title {
                display: flex;
                flex-direction: row;
                align-items: center;
                font-size: 0.87rem;
                padding-bottom: .13rem;
                border-bottom: 0.27rem solid #FF9600;
            }

            .con-sec {
                width: 100%;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/view/Informationmobilehb/index.vue